import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(2),
    margin: '0 60px 60px',
    width: 'auto',
    [theme.breakpoints.down('xs')]: {
      margin: '10px 20px',
    },
  },
}))

export default useStyles
